<template>
  <div>
    <v-dialog
      v-for="dialog in dialogs"
      :key="dialog.key"
      :value="true"
      :width="dialog.width"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      :persistent="dialog.persistent"
      :retain-focus="false"
      scrollable
      @click:outside="closeOutside(dialog)"
    >
      <v-card>
        <v-card-title class="py-2 px-3 grey lighten-4">
          <v-icon left color="indigo">mdi-tab-edit</v-icon>
          <span class="text-subtitle-1 font-weight-medium">{{ dialog.title }}</span>
          <v-spacer />
          <v-btn icon @click="close(dialog.key)"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0">
          <EditTabulation
            :module-id="dialog.moduleId"
            :tabulation-id="dialog.tabulationId"
            :context-key="dialog.contextKey"
            embedded
            @saved="saved(dialog, $event)"
            @close="close(dialog.key)"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EditTabulation from './editTabulations.vue'
import {
  closeTabulationEditor,
  notifyTabulationSaved,
  tabulationEditorDialogs,
} from './navigation'

export default {
  name: 'TabulationEditorDialogHost',
  components: { EditTabulation },
  computed: {
    dialogs() {
      return tabulationEditorDialogs.items
    },
  },
  methods: {
    close(key) {
      closeTabulationEditor(key)
    },
    closeOutside(dialog) {
      if (!dialog.persistent) this.close(dialog.key)
    },
    saved(dialog, tabulation) {
      notifyTabulationSaved(dialog.key, tabulation)
    },
  },
}
</script>
